// // src/pages/Dashboard.jsx
// import React, { useState, useEffect } from "react";
// import styled, { keyframes, createGlobalStyle } from "styled-components";
// import { Link, useNavigate } from "react-router-dom";
// import { connect } from "react-redux";
// import {
//   Briefcase,
//   Send,
//   Clock,
//   CheckCircle,
//   Calendar,
//   DollarSign,
//   Users,
//   Eye,
//   Settings,
//   Plus,
// } from "lucide-react";

// import NavBar from "../components/layout/NavBar";
// import { request } from "../services/networking/request";
// import { API_CONSTANT_MAP } from "../utils/constants/endpoints";

// // Helper function to convert text to title case
// const toTitleCase = (str) => {
//   if (!str) return str;
//   return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
// };

// /* ------------------------- THEME ------------------------- */
// const theme = {
//   colors: {
//     primary: "#3b82f6",
//     primaryLight: "#eff6ff",
//     primaryText: "#3b82f6",
//     textHeading: "#0f172a",
//     textBody: "#334155",
//     textMuted: "#64748b",
//     background: "#f8fafc",
//     surface: "#ffffff",
//     border: "#e2e8f0",
//     success: "#059669",
//   },
//   shadows: {
//     sm: "0 1px 3px rgba(15, 23, 42, 0.06)",
//     md: "0 4px 16px rgba(15, 23, 42, 0.08)",
//     lg: "0 8px 32px rgba(15, 23, 42, 0.12)",
//   },
//   font: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
//   borderRadius: "16px",
// };

// const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
// const slideInUp = keyframes`from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); }`;
// const shimmer = keyframes`0% { background-position: 200% 0; } 100% { background-position: -200% 0; }`;

// /* ------------------------- Global ------------------------- */
// const GlobalStyle = createGlobalStyle`
//   body {
//     background-color: ${theme.colors.background};
//     font-family: ${theme.font};
//     -webkit-font-smoothing: antialiased;
//     -moz-osx-font-smoothing: grayscale;
//   }
// `;

// /* ------------------------- Skeleton Primitives ------------------------- */
// const Skeleton = styled.div`
//   width: ${(p) => p.w || "100%"};
//   height: ${(p) => p.h || "14px"};
//   border-radius: ${(p) => p.r || "10px"};
//   background: linear-gradient(90deg, #eef2f7 0%, #f7f9fc 40%, #eef2f7 80%);
//   background-size: 200% 100%;
//   animation: ${shimmer} 1.2s ease-in-out infinite;
//   max-width: 100%; /* Ensure skeleton never exceeds container */
//   box-sizing: border-box;
// `;

// const SkeletonCard = styled.div`
//   background: ${theme.colors.surface};
//   border: 1px solid ${theme.colors.border};
//   border-radius: ${theme.borderRadius};
//   padding: ${(p) => p.p || "1rem"};
//   box-shadow: ${theme.shadows.sm};
//   animation: ${slideInUp} 0.3s ease;
// `;

// /* ------------------------- Layout ------------------------- */
// const PageWrapper = styled.div`
//   min-height: 100vh;
//   padding-top: 64px;
//   background: linear-gradient(180deg, #fafbff 0%, #f8fafc 50%, #f1f5f9 100%);
// `;

// const ContentContainer = styled.div`
//   max-width: 1280px;
//   margin: 0 auto;
//   padding: 24px;
//   @media (max-width: 1024px) {
//     padding: 16px;
//     width: 100%;
//     max-width: 100vw;
//     overflow-x: hidden;
//   }
// `;

// /* ------------------------- Header ------------------------- */
// const HeaderBlock = styled.header`
//   background: linear-gradient(135deg, #ffffff 0%, #fafbff 100%);
//   border: 1px solid #f1f5f9;
//   border-radius: ${theme.borderRadius};
//   padding: 0.875rem 1.25rem;
//   box-shadow: ${theme.shadows.sm};
//   margin-bottom: 1rem;
//   text-align: center;
//   transition: all 0.2s ease;

//   &:hover {
//     border-color: ${theme.colors.border};
//     box-shadow: ${theme.shadows.md};
//     transform: translateY(-1px);
//   }

//   @media (max-width: 640px) {
//     padding: 0.75rem;
//     margin-bottom: 1rem;
//   }
// `;

// const PageTitle = styled.h1`
//   margin: 0 0 2px;
//   color: ${theme.colors.textHeading};
//   font-size: 1.375rem;
//   font-weight: 700;
//   letter-spacing: -0.02em;

//   @media (max-width: 640px) {
//     font-size: 1.25rem;
//   }
// `;

// const PageSubtitle = styled.p`
//   margin: 0;
//   color: ${theme.colors.textMuted};
//   font-size: 0.875rem;
//   line-height: 1.4;
//   max-width: 500px;
//   margin: 0 auto;

//   @media (max-width: 640px) {
//     font-size: 0.8125rem;
//   }
// `;

// /* ------------------------- Metrics ------------------------- */
// const MetricsGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(4, minmax(0, 1fr));
//   gap: 0.75rem;
//   margin-bottom: 1.25rem;

//   @media (max-width: 1024px) {
//     grid-template-columns: repeat(2, minmax(0, 1fr));
//     gap: 0.625rem;
//     margin-bottom: 1.25rem;
//   }
//   @media (max-width: 560px) {
//     grid-template-columns: repeat(2, minmax(0, 1fr));
//     gap: 0.5rem;
//     margin-bottom: 1.25rem;
//   }
// `;

// const MetricCard = styled.button`
//   background: linear-gradient(135deg, #ffffff 0%, #fafbff 100%);
//   border-radius: ${theme.borderRadius};
//   padding: 0.75rem;
//   border: 1px solid #f1f5f9;
//   box-shadow: ${theme.shadows.md};
//   cursor: pointer;
//   transition: transform 120ms ease, box-shadow 120ms ease,
//     border-color 120ms ease, background 120ms ease;
//   text-align: left;
//   position: relative;
//   overflow: hidden;

//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: ${theme.shadows.lg};
//     border-color: ${theme.colors.primary};
//   }

//   /* Specific hover backgrounds based on icon colors */
//   &:nth-child(1):hover {
//     background: #eff6ff; /* Tasks Posted - very light blue */
//     border-color: ${theme.colors.primary};

//     svg {
//       color: #1e3a8a !important; /* Darker blue icon on hover */
//     }
//   }

//   &:nth-child(2):hover {
//     background: #f0fdf4; /* Offers Sent - very light green */
//     border-color: #059669;

//     svg {
//       color: #14532d !important; /* Darker green icon on hover */
//     }
//   }

//   &:nth-child(3):hover {
//     background: #eff6ff; /* Active Projects - very light blue */
//     border-color: #1e40af;

//     svg {
//       color: #1e3a8a !important; /* Darker blue icon on hover */
//     }
//   }

//   &:nth-child(4):hover {
//     background: hsl(271, 100%, 98%); /* Completed Tasks - very light purple */
//     border-color: #7c3aed;

//     svg {
//       color: #4c1d95 !important; /* Darker purple icon on hover */
//     }
//   }

//   @media (max-width: 640px) {
//     padding: 0.7rem;
//   }
// `;

// const CardHeader = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// `;

// const MetricTitle = styled.h3`
//   font-size: 0.8rem;
//   letter-spacing: 0.03em;
//   text-transform: uppercase;
//   font-weight: 700;
//   color: ${theme.colors.textMuted};
//   margin: 0;

//   @media (max-width: 640px) {
//     font-size: 0.78rem;
//   }
// `;

// const IconWrapper = styled.div`
//   background: ${({ bg }) => bg || theme.colors.primaryLight};
//   padding: 0.375rem;
//   border-radius: 0.5rem;
//   display: flex;
//   border: 1px solid ${theme.colors.border};
// `;

// const MetricValue = styled.div`
//   font-size: 1.75rem;
//   font-weight: 900;
//   color: ${theme.colors.textHeading};
//   margin: 0.375rem 0 0.125rem;
//   letter-spacing: -0.02em;

//   @media (max-width: 640px) {
//     font-size: 1.5rem;
//   }
// `;

// const MetricSub = styled.div`
//   font-size: 0.75rem;
//   color: ${theme.colors.textMuted};

//   @media (max-width: 640px) {
//     font-size: 0.7rem;
//   }
// `;

// /* ------------------------- Tabs + Pills ------------------------- */
// const TabsContainer = styled.div`
//   margin-bottom: 1.25rem;

//   @media (max-width: 640px) {
//     margin-bottom: 1rem;
//   }
// `;

// const MainTabs = styled.div`
//   display: flex;
//   gap: 2px;
//   background: #f8fafc;
//   border-radius: 12px;
//   padding: 4px;
//   box-shadow: inset 0 1px 3px rgba(15, 23, 42, 0.1);
//   width: fit-content;
//   max-width: 500px;

//   @media (max-width: 640px) {
//     width: 100%;
//     max-width: 100%;
//   }
// `;

// const MainTabButton = styled.button`
//   flex: 1;
//   background: ${props => props.active ? 'linear-gradient(135deg, #3b82f6 0%, #6366f1 100%)' : 'transparent'};
//   border: none;
//   border-radius: 10px;
//   padding: 8px 10px;
//   font-weight: 700;
//   font-size: 0.9rem;
//   color: ${props => props.active ? '#ffffff' : theme.colors.textMuted};
//   cursor: pointer;
//   transition: all 0.2s ease;
//   box-shadow: ${props => props.active ? '0 2px 8px rgba(59, 130, 246, 0.2)' : 'none'};
//   transform: ${props => props.active ? 'translateY(-1px)' : 'none'};
//   white-space: nowrap;
//   text-align: center;

//   &:hover {
//     color: ${props => props.active ? '#ffffff' : '#3b82f6'};
//     background: ${props => props.active ? 'linear-gradient(135deg, #2563eb 0%, #5b5bf6 100%)' : 'rgba(255, 255, 255, 0.5)'};
//   }

//   @media (max-width: 640px) {
//     padding: 10px 8px;
//     font-size: 0.85rem;
//   }
// `;

// const FilterPills = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   gap: 0.4rem;
//   margin-bottom: 1.5rem;

//   @media (max-width: 640px) {
//     gap: 0.3rem;
//     margin-bottom: 1.5rem;
//   }
// `;

// const Pill = styled.button`
//   padding: 0.4rem 0.7rem;
//   font-size: 0.85rem;
//   border-radius: 9999px;
//   border: 1px solid
//     ${({ active }) => (active ? "#3b82f6" : theme.colors.border)};
//   background: ${({ active }) =>
//     active ? "linear-gradient(135deg, #3b82f6 0%, #6366f1 100%)" : theme.colors.surface};
//   color: ${({ active }) => (active ? "#ffffff" : theme.colors.textBody)};
//   cursor: pointer;
//   box-shadow: ${theme.shadows.sm};
//   font-weight: 700;
//   transition: transform 100ms ease, box-shadow 120ms ease;
//   white-space: nowrap;

//   &:hover {
//     transform: translateY(-1px);
//     box-shadow: ${theme.shadows.md};
//     background: ${({ active }) =>
//       active ? "linear-gradient(135deg, #2563eb 0%, #5b5bf6 100%)" : theme.colors.surface};
//   }

//   @media (max-width: 640px) {
//     font-size: 0.8rem;
//     padding: 0.35rem 0.6rem;
//   }
// `;

// /* ------------------------- List ------------------------- */
// const TaskCard = styled.div`
//   background: linear-gradient(135deg, #ffffff 0%, #fafbff 100%);
//   border: 1px solid #e5e7eb;
//   border-radius: 16px;
//   padding: 1.5rem;
//   box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
//   margin-bottom: 1.5rem;
//   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//   animation: ${slideInUp} 0.3s ease;
//   position: relative;
//   overflow: hidden;

//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
//     border-color: #cbd5e1;
//   }

//   @media (max-width: 640px) {
//     padding: 1.25rem;
//     border-radius: 12px;
//     margin-bottom: 1.25rem;
//   }
// `;

// const TaskHeader = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: start;
//   gap: 1rem;

//   @media (max-width: 640px) {
//     flex-direction: column;
//     gap: 0.75rem;
//   }
// `;

// const TitleBlock = styled.div`
//   min-width: 0; /* allow ellipsis */
// `;

// const TaskTitleLink = styled(Link)`
//   display: block;
//   max-width: 100%;
//   font-size: 1.125rem;
//   font-weight: 700;
//   color: ${theme.colors.textHeading};
//   letter-spacing: -0.01em;
//   line-height: 1.3;
//   text-decoration: none;
//   cursor: pointer;
//   word-wrap: break-word;
//   word-break: break-word;
//   overflow-wrap: break-word;
//   transition: color 0.15s ease;

//   &:hover {
//     color: ${theme.colors.primary};
//   }

//   @media (max-width: 640px) {
//     font-size: 1.05rem;
//   }
// `;

// const Tag = styled.span`
//   display: inline-block;
//   background: ${({ bg }) => bg || theme.colors.primaryLight};
//   color: ${({ color }) => color || theme.colors.primary};
//   font-size: 0.7rem;
//   padding: 0.25rem 0.5rem;
//   border-radius: 12px;
//   margin-top: 0.5rem;
//   border: 1px solid rgba(0, 0, 0, 0.05);
//   font-weight: 500;
//   letter-spacing: -0.01em;
//   box-shadow: ${theme.shadows.sm};
// `;

// const ButtonGroup = styled.div`
//   display: flex;
//   gap: 0.4rem;
//   flex-wrap: wrap;

//   @media (max-width: 640px) {
//     width: 100%;
//   }
// `;

// const OutlineButton = styled.button`
//   display: inline-flex;
//   align-items: center;
//   gap: 0.4rem;
//   padding: 0.4rem 0.6rem;
//   font-size: 0.8rem;
//   background: linear-gradient(135deg, #ffffff 0%, #fafbff 100%);
//   color: ${theme.colors.textBody};
//   border: 1px solid #f1f5f9;
//   border-radius: 10px;
//   cursor: pointer;
//   font-weight: 700;
//   transition: all 120ms ease;
//   box-shadow: ${theme.shadows.sm};

//   &:hover {
//     background: linear-gradient(135deg, ${theme.colors.primaryLight} 0%, #f0f7ff 100%);
//     color: ${theme.colors.primary};
//     transform: translateY(-1px);
//     box-shadow: ${theme.shadows.md};
//     border-color: ${theme.colors.primary};
//   }

//   @media (max-width: 640px) {
//     flex: 1 1 48%;
//     justify-content: center;
//     padding: 0.6rem;
//     font-size: 0.8rem;
//   }
// `;

// const SolidButton = styled(OutlineButton)`
//   background: linear-gradient(135deg, #3b82f6 0%, #6366f1 100%);
//   color: #ffffff;
//   border: none;
//   box-shadow: 0 4px 14px rgba(59, 130, 246, 0.25);

//   &:hover {
//     background: linear-gradient(135deg, #2563eb 0%, #5b5bf6 100%);
//     color: #fff;
//     box-shadow: 0 6px 20px rgba(59, 130, 246, 0.35);
//     transform: translateY(-2px);
//   }
// `;

// const DetailRow = styled.div`
//   display: flex;
//   gap: 1rem;
//   margin: 0.75rem 0 0;
//   padding: 0.75rem 0 0;
//   border-top: 1px solid #f1f5f9;
//   color: ${theme.colors.textMuted};
//   font-size: 0.85rem;
//   align-items: center;
//   flex-wrap: wrap;

//   @media (max-width: 640px) {
//     flex-direction: column;
//     align-items: flex-start;
//     gap: 0.5rem;
//     font-size: 0.8rem;
//     margin-top: 0.5rem;
//     padding-top: 0.5rem;
//   }
// `;

// const IconText = styled.span`
//   display: inline-flex;
//   align-items: center;
//   gap: 0.5rem;
//   font-size: 0.875rem;
//   color: ${theme.colors.textBody};
//   font-weight: 500;
//   padding: 0.3rem 0.75rem;
//   background: rgba(248, 250, 252, 0.8);
//   border-radius: 8px;
//   border: 1px solid rgba(241, 245, 249, 0.6);
//   transition: all 0.2s ease;

//   svg {
//     flex-shrink: 0;
//   }

//   &:hover {
//     background: rgba(241, 245, 249, 0.9);
//     border-color: rgba(203, 213, 225, 0.8);
//   }

//   @media (max-width: 640px) {
//     font-size: 0.8rem;
//     gap: 0.375rem;
//     padding: 0.25rem 0.6rem;
//   }
// `;

// /* ------------------------- Empty State ------------------------- */
// const EmptyState = styled.div`
//   background: linear-gradient(135deg, #ffffff 0%, #fafbff 100%);
//   border: 1px solid #f1f5f9;
//   border-radius: ${theme.borderRadius};
//   padding: 2.5rem 1.5rem;
//   text-align: center;
//   box-shadow: ${theme.shadows.lg};
//   animation: ${slideInUp} 0.3s ease;

//   @media (max-width: 640px) {
//     padding: 2rem 1.2rem;
//   }
// `;

// const EmptyIcon = styled.div`
//   width: 72px;
//   height: 72px;
//   border-radius: 50%;
//   background: linear-gradient(135deg, ${theme.colors.primaryLight} 0%, #f0f7ff 100%);
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   margin: 0 auto 1.2rem;
//   border: 1px solid rgba(59, 130, 246, 0.1);

//   @media (max-width: 640px) {
//     width: 64px;
//     height: 64px;
//     margin-bottom: 1rem;
//   }
// `;

// const EmptyTitle = styled.h3`
//   margin: 0 0 0.75rem;
//   color: ${theme.colors.textHeading};
//   font-size: 1.25rem;
//   font-weight: 700;

//   @media (max-width: 640px) {
//     font-size: 1.1rem;
//     margin-bottom: 0.5rem;
//   }
// `;

// const EmptyText = styled.p`
//   margin: 0 0 1.5rem;
//   color: ${theme.colors.textMuted};
//   font-size: 1rem;
//   line-height: 1.6;
//   max-width: 400px;
//   margin-left: auto;
//   margin-right: auto;

//   @media (max-width: 640px) {
//     font-size: 0.95rem;
//     margin-bottom: 1.25rem;
//   }
// `;

// const EmptyButton = styled.button`
//   display: inline-flex;
//   align-items: center;
//   gap: 0.5rem;
//   padding: 1rem 2rem;
//   background: linear-gradient(135deg, #3b82f6 0%, #6366f1 100%);
//   color: white;
//   border: none;
//   border-radius: 12px;
//   font-size: 1.1rem;
//   font-weight: 700;
//   cursor: pointer;
//   transition: all 0.2s ease;
//   box-shadow: 0 4px 16px rgba(59, 130, 246, 0.3);
//   letter-spacing: -0.01em;

//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 8px 32px rgba(59, 130, 246, 0.4);
//     background: linear-gradient(135deg, #2563eb 0%, #6366f1 100%);
//   }

//   @media (max-width: 640px) {
//     padding: 0.875rem 1.5rem;
//     font-size: 1rem;
//   }
// `;

// /* ------------------------- Loading Skeleton Layouts ------------------------- */
// const HeaderSkeleton = () => (
//   <SkeletonCard p="0.875rem 1.25rem" style={{ marginBottom: "1rem" }}>
//     <Skeleton w="min(240px, 70%)" h="20px" r="8px" />
//     <div style={{ marginTop: 4 }}>
//       <Skeleton w="min(300px, 80%)" h="12px" />
//     </div>
//   </SkeletonCard>
// );

// const MetricsSkeleton = () => (
//   <MetricsGrid>
//     {Array.from({ length: 4 }).map((_, i) => (
//       <SkeletonCard key={i}>
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >
//           <Skeleton w="120px" h="12px" />
//           <Skeleton w="36px" h="32px" r="8px" />
//         </div>
//         <div style={{ marginTop: 12 }}>
//           <Skeleton w="80px" h="22px" />
//         </div>
//         <div style={{ marginTop: 8 }}>
//           <Skeleton w="130px" h="12px" />
//         </div>
//       </SkeletonCard>
//     ))}
//   </MetricsGrid>
// );

// const PillsSkeleton = () => (
//   <div
//     style={{
//       margin: "12px 0 16px",
//       display: "flex",
//       gap: "8px",
//       flexWrap: "wrap",
//       overflow: "hidden", /* Prevent overflow */
//     }}
//   >
//     {Array.from({ length: 5 }).map((_, i) => (
//       <Skeleton key={i} w={`min(${80 + i * 18}px, 25%)`} h="32px" r="999px" />
//     ))}
//   </div>
// );

// const ListSkeleton = () => (
//   <>
//     {Array.from({ length: 4 }).map((_, i) => (
//       <SkeletonCard key={i} style={{ marginBottom: "1rem" }}>
//         <div
//           style={{ display: "flex", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}
//         >
//           <div style={{ flex: "1 1 0", minWidth: 0 }}>
//             <Skeleton w="min(320px, 100%)" h="18px" />
//             <div
//               style={{
//                 marginTop: 10,
//                 display: "flex",
//                 gap: 8,
//                 alignItems: "center",
//               }}
//             >
//               <Skeleton w="90px" h="24px" r="999px" />
//               <Skeleton w="70px" h="24px" r="999px" />
//             </div>
//           </div>
//           <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
//             <Skeleton w="100px" h="34px" r="10px" />
//             <Skeleton w="110px" h="34px" r="10px" />
//           </div>
//         </div>
//         <div
//           style={{ marginTop: 14, display: "flex", gap: 14, flexWrap: "wrap" }}
//         >
//           <Skeleton w="80px" h="16px" />
//           <Skeleton w="min(160px, 40%)" h="16px" />
//           <Skeleton w="120px" h="16px" />
//         </div>
//       </SkeletonCard>
//     ))}
//   </>
// );

// /* ------------------------- Component ------------------------- */
// const Dashboard = ({ state }) => {
//   const [postedTasks, setPostedTasks] = useState([]);
//   const [offers, setOffers] = useState([]);
//   const [mainTab, setMainTab] = useState("posted");
//   const [filter, setFilter] = useState("all");
//   const [isLoading, setIsLoading] = useState(true);
//   const navigate = useNavigate();

//   useEffect(() => {
//     (async () => {
//       setIsLoading(true);
//       try {
//         const [tResp, aResp] = await Promise.all([
//           request("POST", API_CONSTANT_MAP.fetch_posted_tasks),
//           request("POST", API_CONSTANT_MAP.fetch_user_offers),
//         ]);
//         if (tResp.data?.success) setPostedTasks(tResp.data.tasks || []);
//         if (aResp.data?.success) setOffers(aResp.data.applications || []);
//       } catch (e) {
//         console.error(e);
//       } finally {
//         setIsLoading(false);
//       }
//     })();
//   }, []);

//   const counts = {
//     tasksPosted: postedTasks.length,
//     offersSent: offers.length,
//     activeProjects: postedTasks.filter((t) => t.status === "in_progress")
//       .length,
//     completedTasks: postedTasks.filter((t) => t.status === "completed").length,
//   };

//   const tasksList = mainTab === "posted" ? postedTasks : offers;
//   const pillKeys =
//     mainTab === "posted"
//       ? ["all", "open", "in_progress", "completed"]
//       : ["all", "pending", "accepted", "rejected"];
//   const filtered =
//     filter === "all" ? tasksList : tasksList.filter((t) => t.status === filter);

//   return (
//     <>
//       <GlobalStyle />
//       <PageWrapper>
//         <NavBar user={state.user} />
//         <ContentContainer>
//             {/* HEADER */}
//             {isLoading ? (
//               <HeaderSkeleton />
//             ) : (
//               <HeaderBlock>
//                 <PageTitle>Welcome back, {state.user.first_name}!</PageTitle>
//                 <PageSubtitle>
//                   Manage your tasks and track your progress
//                 </PageSubtitle>
//               </HeaderBlock>
//             )}

//             {/* METRICS */}
//             {isLoading ? (
//               <MetricsSkeleton />
//             ) : (
//               <MetricsGrid>
//                 <MetricCard
//                   onClick={() => {
//                     setMainTab("posted");
//                     setFilter("all");
//                   }}
//                 >
//                   <CardHeader>
//                     <MetricTitle>Tasks Posted</MetricTitle>
//                     <IconWrapper bg={theme.colors.primaryLight}>
//                       <Briefcase size={18} color="hsl(217, 91%, 50%)" />
//                     </IconWrapper>
//                   </CardHeader>
//                   <MetricValue>{counts.tasksPosted}</MetricValue>
//                   <MetricSub>Click to filter below</MetricSub>
//                 </MetricCard>

//                 <MetricCard
//                   onClick={() => {
//                     setMainTab("offers");
//                     setFilter("all");
//                   }}
//                 >
//                   <CardHeader>
//                     <MetricTitle>Offers Sent</MetricTitle>
//                     <IconWrapper bg="hsl(145, 63%, 95%)">
//                       <Send size={18} color="hsl(145, 63%, 42%)" />
//                     </IconWrapper>
//                   </CardHeader>
//                   <MetricValue>{counts.offersSent}</MetricValue>
//                   <MetricSub>Click to filter below</MetricSub>
//                 </MetricCard>

//                 <MetricCard
//                   onClick={() => {
//                     setMainTab("posted");
//                     setFilter("in_progress");
//                   }}
//                 >
//                   <CardHeader>
//                     <MetricTitle>Active Projects</MetricTitle>
//                     <IconWrapper bg="hsl(217, 91%, 92%)">
//                       <Clock size={18} color="#3b82f6" />
//                     </IconWrapper>
//                   </CardHeader>
//                   <MetricValue>{counts.activeProjects}</MetricValue>
//                   <MetricSub>Click to filter below</MetricSub>
//                 </MetricCard>

//                 <MetricCard
//                   onClick={() => {
//                     setMainTab("posted");
//                     setFilter("completed");
//                   }}
//                 >
//                   <CardHeader>
//                     <MetricTitle>Completed Tasks</MetricTitle>
//                     <IconWrapper bg="#f3e8ff">
//                       <CheckCircle size={18} color="#8b5cf6" />
//                     </IconWrapper>
//                   </CardHeader>
//                   <MetricValue>{counts.completedTasks}</MetricValue>
//                   <MetricSub>Click to filter below</MetricSub>
//                 </MetricCard>
//               </MetricsGrid>
//             )}

//             {/* TABS */}
//             <TabsContainer>
//               {isLoading ? (
//                 <SkeletonCard>
//                   <Skeleton w="min(220px, 60%)" h="38px" r="12px" />
//                 </SkeletonCard>
//               ) : (
//                 <MainTabs>
//                   <MainTabButton
//                     active={mainTab === "posted"}
//                     onClick={() => {
//                       setMainTab("posted");
//                       setFilter("all");
//                     }}
//                   >
//                     My Posted Tasks
//                   </MainTabButton>
//                   <MainTabButton
//                     active={mainTab === "offers"}
//                     onClick={() => {
//                       setMainTab("offers");
//                       setFilter("all");
//                     }}
//                   >
//                     My Offers
//                   </MainTabButton>
//                 </MainTabs>
//               )}
//             </TabsContainer>

//             {/* FILTER PILLS */}
//             {isLoading ? (
//               <PillsSkeleton />
//             ) : (
//               <FilterPills>
//                 {pillKeys.map((key) => {
//                   const label =
//                     key === "all"
//                       ? `${
//                           mainTab === "posted"
//                             ? "All Tasks"
//                             : "All Offers"
//                         } (${tasksList.length})`
//                       : `${key.charAt(0).toUpperCase() + key.slice(1)} (${
//                           tasksList.filter((t) => t.status === key).length
//                         })`;
//                   return (
//                     <Pill
//                       key={key}
//                       active={filter === key}
//                       onClick={() => setFilter(key)}
//                     >
//                       {label
//                         .split("_")
//                         .map(
//                           (w) =>
//                             w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
//                         )
//                         .join(" ")}
//                     </Pill>
//                   );
//                 })}
//               </FilterPills>
//             )}

//             {/* LIST */}
//             {isLoading ? (
//               <ListSkeleton />
//             ) : filtered.length === 0 ? (
//               <EmptyState>
//                 <EmptyTitle>
//                   {mainTab === "posted" ? "No tasks posted yet" : "No offers sent yet"}
//                 </EmptyTitle>
//                 <EmptyText>
//                   {mainTab === "posted"
//                     ? "Ready to get things done? Post your first task and start receiving proposals from skilled service providers."
//                     : "Browse available tasks and send your first proposal to start earning."}
//                 </EmptyText>
//                 <EmptyButton
//                   onClick={() => navigate(mainTab === "posted" ? "/posttask" : "/tasks")}
//                 >
//                   <Plus size={20} />
//                   {mainTab === "posted" ? "Post Your First Request" : "Find Work"}
//                 </EmptyButton>
//               </EmptyState>
//             ) : (
//               filtered.map((t) => (
//                 <TaskCard key={t.id}>
//                   <TaskHeader style={{ flexDirection: "column", gap: "1rem" }}>
//                     <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%" }}>
//                       <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", flex: 1 }}>
//                         <TaskTitleLink to={`/tasks/${t.id}`}>
//                           {toTitleCase(mainTab === "posted" ? t.title : t.task_title)}
//                         </TaskTitleLink>
//                         <Tag
//                           bg={
//                             t.status === "completed"
//                               ? "hsl(145, 63%, 95%)" // Green for completed
//                               : t.status === "in_progress"
//                               ? "hsl(217, 91%, 95%)" // Blue for in progress
//                               : t.status === "open" || t.status === "pending"
//                               ? "hsl(35, 91%, 95%)" // Orange for waiting/pending
//                               : t.status === "accepted"
//                               ? "hsl(217, 91%, 95%)" // Blue for accepted
//                               : t.status === "rejected"
//                               ? "hsl(0, 84%, 95%)" // Red for rejected
//                               : "hsl(220, 13%, 95%)" // Gray for other states
//                           }
//                           color={
//                             t.status === "completed"
//                               ? "hsl(145, 63%, 35%)" // Dark green for completed
//                               : t.status === "in_progress"
//                               ? "hsl(217, 91%, 45%)" // Blue for in progress
//                               : t.status === "open" || t.status === "pending"
//                               ? "hsl(35, 91%, 45%)" // Orange for waiting/pending
//                               : t.status === "accepted"
//                               ? "hsl(217, 91%, 45%)" // Blue for accepted
//                               : t.status === "rejected"
//                               ? "hsl(0, 84%, 45%)" // Red for rejected
//                               : "hsl(220, 13%, 45%)" // Gray for other states
//                           }
//                           style={{ margin: "0", flexShrink: 0 }}
//                         >
//                           {t.status
//                             .split("_")
//                             .map(
//                               (w) =>
//                                 w.charAt(0).toUpperCase() +
//                                 w.slice(1).toLowerCase()
//                             )
//                             .join(" ")}
//                         </Tag>
//                       </div>

//                       <ButtonGroup>
//                         {mainTab === "posted" ? (
//                           <>
//                             {t.conversation_id && (
//                               <OutlineButton
//                                 onClick={() =>
//                                   navigate(`/chat/${t.conversation_id}`)
//                                 }
//                               >
//                                 <Eye size={16} /> View Chat
//                               </OutlineButton>
//                             )}
//                             <SolidButton
//                               onClick={() => navigate(`/tasks/${t.id}/manage`)}
//                             >
//                               <Settings size={16} /> Manage
//                             </SolidButton>
//                           </>
//                         ) : (
//                           // Only show View Chat for accepted offers
//                           t.status === "accepted" && (
//                             <OutlineButton
//                               onClick={() =>
//                                 navigate(`/chat/${t.conversation_id || ""}`)
//                               }
//                             >
//                               <Eye size={16} /> View Chat
//                             </OutlineButton>
//                           )
//                         )}
//                       </ButtonGroup>
//                     </div>

//                     <DetailRow style={{ margin: "0" }}>
//                       {mainTab === "posted" ? (
//                         <>
//                           <IconText style={{ color: "hsl(145, 63%, 42%)" }}>
//                             <DollarSign size={16} />${t.budget}
//                           </IconText>
//                           <IconText>
//                             <Calendar size={16} color={theme.colors.textMuted} />
//                             Due {t.due_date}
//                           </IconText>
//                           <IconText>
//                             <Users size={16} color={theme.colors.textMuted} />
//                             {t.proposals} offer{t.proposals !== 1 ? "s" : ""}
//                           </IconText>
//                         </>
//                       ) : (
//                         <>
//                           <IconText style={{ color: "hsl(145, 63%, 42%)" }}>
//                             Budget: ${t.budget}
//                           </IconText>
//                           <IconText style={{ color: "hsl(217, 91%, 60%)" }}>
//                             My Offer: ${t.amount}
//                           </IconText>
//                           <IconText>
//                             <Calendar size={16} color={theme.colors.textMuted} />
//                             Due {t.task_due_date}
//                           </IconText>
//                         </>
//                       )}
//                     </DetailRow>
//                   </TaskHeader>
//                 </TaskCard>
//               ))
//             )}
//         </ContentContainer>
//       </PageWrapper>
//     </>
//   );
// };

// export default connect((state) => ({ state }))(Dashboard);
import React, { useState, useEffect, useCallback } from "react";
import styled, { keyframes, createGlobalStyle } from "styled-components";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { connect } from "react-redux";
import {
  Briefcase,
  Send,
  Clock,
  CheckCircle,
  Calendar,
  DollarSign,
  Users,
  Eye,
  Settings,
  Plus,
  Inbox,
  ArrowRight,
  ExternalLink,
  MessageCircle,
} from "lucide-react";
import { formatDistanceToNow } from "date-fns";

import NavBar from "../components/layout/NavBar";
import AvatarComponent from "../components/Avatar";
import VerificationBadge from "../components/common/VerificationBadge";
import { request } from "../services/networking/request";
import { API_CONSTANT_MAP } from "../utils/constants/endpoints";

// Helper function to convert text to title case
const toTitleCase = (str) => {
  if (!str) return str;
  return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};

/* ------------------------- THEME (Airbnb-inspired layout with original colors) ------------------------- */
const theme = {
  colors: {
    primary: "#3b82f6",
    primaryLight: "#eff6ff",
    primaryText: "#3b82f6",
    textHeading: "#0f172a",
    textBody: "#334155",
    textMuted: "#64748b",
    background: "#f8fafc",
    surface: "#ffffff",
    border: "#e2e8f0",
    borderLight: "#f1f5f9",
    success: "#059669",
    warning: "#f59e0b",
    error: "#dc2626",
    accent: "#8b5cf6",
  },
  shadows: {
    sm: "0 1px 2px rgba(15, 23, 42, 0.04)",
    md: "0 6px 16px rgba(15, 23, 42, 0.06)",
    lg: "0 10px 24px rgba(15, 23, 42, 0.08)",
    card: "0 10px 24px rgba(15, 23, 42, 0.08)",
  },
  fonts: {
    primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    weights: {
      light: 300,
      normal: 400,
      medium: 500,
      semiBold: 600,
      bold: 700,
    }
  },
  borderRadius: {
    sm: "8px",
    md: "12px",
    lg: "14px",
    xl: "18px",
  },
};

const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const slideInUp = keyframes`from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); }`;
const shimmer = keyframes`0% { background-position: 200% 0; } 100% { background-position: -200% 0; }`;

/* ------------------------- BUTTON DESCRIPTIONS ------------------------- */
const ButtonWithDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

const ButtonDescription = styled.span`
  font-size: 10px;
  color: ${theme.colors.textMuted};
  text-align: center;
  line-height: 1.2;
  max-width: 120px;
`;

/* ------------------------- INFO SECTION ------------------------- */
const InfoSection = styled.div`
  background: ${theme.colors.primaryLight};
  border: 1px solid #dbeafe;
  border-radius: ${theme.borderRadius};
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  font-size: 0.85rem;
  color: ${theme.colors.textBody};
  line-height: 1.5;

  strong {
    color: ${theme.colors.textHeading};
    font-weight: 600;
  }
`;

const InfoTitle = styled.span`
  font-weight: 600;
  color: ${theme.colors.textHeading};
`;

/* ------------------------- TOOLTIP ------------------------- */
const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
  overflow: visible;
`;

const TooltipContent = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: ${theme.colors.textHeading};
  color: white;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  pointer-events: none;
  margin-bottom: 8px;
  
  /* Arrow pointing down to button */
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid ${theme.colors.textHeading};
  }

  ${TooltipWrapper}:hover & {
    opacity: 1;
    visibility: visible;
    transform: translateX(-50%) translateY(-4px);
  }
`;

/* ------------------------- Global ------------------------- */
const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${theme.colors.background};
    font-family: ${theme.fonts.primary};
    font-weight: ${theme.fonts.weights.normal};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: ${theme.colors.textBody};
    line-height: 1.43;
    letter-spacing: 0.01071em;
  }
  
  * {
    box-sizing: border-box;
  }
`;

/* ------------------------- Skeleton Primitives ------------------------- */
const Skeleton = styled.div`
  width: ${(p) => p.w || "100%"};
  height: ${(p) => p.h || "14px"};
  border-radius: ${(p) => p.r || theme.borderRadius.sm};
  background: linear-gradient(90deg, #f1f5f9 0%, #f8fafc 40%, #f1f5f9 80%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;
  max-width: 100%;
  box-sizing: border-box;
`;

const SkeletonCard = styled.div`
  background: ${theme.colors.surface};
  border: 1px solid ${theme.colors.borderLight};
  border-radius: ${theme.borderRadius.lg};
  padding: ${(p) => p.p || "1.25rem"};
  box-shadow: ${theme.shadows.sm};
  animation: ${slideInUp} 0.3s ease;
`;

/* ------------------------- Layout ------------------------- */
const PageWrapper = styled.div`
  min-height: 100vh;
  padding-top: 72px;
  background: ${theme.colors.background};
`;

const ContentContainer = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  padding: 16px;
  
  @media (max-width: 1024px) {
    padding: 12px;
  }
  
  @media (max-width: 768px) {
    padding: 8px;
  }
`;

/* ------------------------- Header ------------------------- */
const HeaderBlock = styled.header`
  background: ${theme.colors.surface};
  border: 1px solid ${theme.colors.borderLight};
  border-radius: ${theme.borderRadius.lg};
  padding: 0.875rem 1.25rem;
  box-shadow: ${theme.shadows.sm};
  margin-bottom: 1rem;
  text-align: left;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    box-shadow: ${theme.shadows.md};
    border-color: #d7e0ee;
  }

  @media (max-width: 768px) {
    padding: 0.75rem;
    margin-bottom: 0.75rem;
    text-align: center;
  }
`;

const PageTitle = styled.h1`
  margin: 0 0 8px 0;
  color: ${theme.colors.textHeading};
  font-size: 1.75rem;
  font-weight: ${theme.fonts.weights.semiBold};
  letter-spacing: -0.025em;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1.375rem;
  }
`;

const PageSubtitle = styled.p`
  margin: 0;
  color: ${theme.colors.textMuted};
  font-size: 0.95rem;
  line-height: 1.5;
  font-weight: ${theme.fonts.weights.normal};
  max-width: 600px;

  @media (max-width: 768px) {
    font-size: 0.875rem;
    margin: 0 auto;
  }
`;

/* ------------------------- Metrics ------------------------- */
const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.75rem;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
  }
`;

const MetricCard = styled.button`
  background: ${theme.colors.surface};
  border-radius: ${theme.borderRadius.lg};
  padding: 0.75rem;
  border: 1px solid ${theme.colors.borderLight};
  box-shadow: ${theme.shadows.sm};
  cursor: pointer;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
  text-align: left;
  position: relative;
  overflow: hidden;

  &:hover {
    box-shadow: ${theme.shadows.md};
    border-color: #d7e0ee;
  }

  @media (max-width: 768px) {
    padding: 0.5rem;
  }
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.5rem;
`;

const MetricTitle = styled.h3`
  font-size: 0.875rem;
  font-weight: ${theme.fonts.weights.medium};
  color: ${theme.colors.textMuted};
  margin: 0;
  line-height: 1.4;
`;

const IconWrapper = styled.div`
  background: ${({ bg }) => bg || theme.colors.primaryLight};
  padding: 0.75rem;
  border-radius: ${theme.borderRadius.md};
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  border: 1px solid ${theme.colors.borderLight};
  transition: border-color 0.2s ease;
`;

const MetricValue = styled.div`
  font-size: 2.5rem;
  font-weight: ${theme.fonts.weights.semiBold};
  color: ${theme.colors.textHeading};
  margin: 0.25rem 0 0.125rem;
  letter-spacing: -0.02em;
  line-height: 1.1;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1.75rem;
  }
`;

const MetricSub = styled.div`
  font-size: 0.875rem;
  color: ${theme.colors.textMuted};
  font-weight: ${theme.fonts.weights.normal};
  line-height: 1.4;
`;

/* ------------------------- Tabs + Pills ------------------------- */
const TabsContainer = styled.div`
  margin-bottom: 1rem;
`;

const MainTabs = styled.div`
  display: flex;
  gap: 4px;
  background: #f8fafc;
  border-radius: ${theme.borderRadius.lg};
  padding: 4px;
  box-shadow: none;
  border: 1px solid ${theme.colors.border};
  width: fit-content;
  max-width: 500px;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
  }
`;

const MainTabButton = styled.button`
  flex: 1;
  background: ${(props) => (props.active ? theme.colors.surface : "transparent")};
  border: 1px solid ${(props) => (props.active ? "#d7e0ee" : "transparent")};
  border-radius: ${theme.borderRadius.md};
  padding: 10px 16px;
  font-weight: ${theme.fonts.weights.semiBold};
  font-size: 0.85rem;
  color: ${(props) => (props.active ? theme.colors.textHeading : theme.colors.textMuted)};
  cursor: pointer;
  transition: box-shadow 0.2s ease, border-color 0.2s ease, color 0.2s ease;
  box-shadow: ${(props) => (props.active ? theme.shadows.sm : "none")};
  white-space: nowrap;
  text-align: center;

  &:hover {
    color: ${theme.colors.textHeading};
    border-color: #d7e0ee;
  }

  &:first-child {
    margin-right: 0;
  }

  @media (max-width: 768px) {
    padding: 10px 12px;
    font-size: 0.82rem;
  }
`;

const FilterPills = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    gap: 0.375rem;
  }
`;

const Pill = styled.button`
  padding: 7px 14px;
  font-size: 0.82rem;
  border-radius: 999px;
  border: 1px solid ${({ active }) => (active ? "#d7e0ee" : theme.colors.border)};
  background: ${({ active }) => (active ? theme.colors.primaryLight : theme.colors.surface)};
  color: ${({ active }) => (active ? theme.colors.primary : theme.colors.textBody)};
  cursor: pointer;
  box-shadow: none;
  font-weight: ${theme.fonts.weights.medium};
  transition: border-color 0.2s ease, color 0.2s ease, background 0.2s ease;
  white-space: nowrap;

  &:hover {
    border-color: #d7e0ee;
    color: ${theme.colors.primary};
  }

  @media (max-width: 768px) {
    font-size: 0.78rem;
    padding: 6px 10px;
  }
`;

/* ------------------------- List ------------------------- */
const TaskCard = styled.div`
  background: ${theme.colors.surface};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.lg};
  padding: 0;
  box-shadow: ${theme.shadows.sm};
  margin-bottom: 0.75rem;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    box-shadow: ${theme.shadows.md};
    border-color: #d7e0ee;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

const CardContent = styled.div`
  padding: 1rem 1.125rem;

  @media (max-width: 768px) {
    padding: 0.875rem;
  }
`;

const TaskHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.625rem;
  margin-bottom: 0.75rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
`;

const TitleAndTag = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  flex: 1;
  min-width: 0;
`;

const TaskTitleLink = styled(Link)`
  font-size: 1rem;
  font-weight: 600;
  color: ${theme.colors.textHeading};
  letter-spacing: -0.01em;
  line-height: 1.35;
  text-decoration: none;
  cursor: pointer;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  transition: color 0.15s ease;

  &:hover {
    color: ${theme.colors.primary};
  }

  @media (max-width: 768px) {
    font-size: 0.95rem;
  }
`;

const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  background: #f8fafc;
  color: ${theme.colors.textMuted};
  font-size: 0.7rem;
  padding: 3px 8px;
  border-radius: 999px;
  font-weight: 600;
  letter-spacing: 0.02em;
  flex-shrink: 0;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 0.65rem;
    padding: 3px 8px;
  }
`;

const ButtonGroup = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    width: 100%;
    gap: 0.5rem;
    margin-top: 0.75rem;
    padding-top: 0.75rem;
    border-top: 1px solid ${theme.colors.borderLight};
  }
`;

const DesktopButtonGroup = styled.div`
  display: flex;
  gap: 0.375rem;
  flex-shrink: 0;

  @media (max-width: 768px) {
    display: none;
  }
`;

const OutlineButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 6px 12px;
  font-size: 0.8rem;
  background: ${theme.colors.surface};
  color: ${theme.colors.textMuted};
  border: 1px solid ${theme.colors.border};
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.15s ease;

  &:hover {
    background: ${theme.colors.primaryLight};
    color: ${theme.colors.primary};
    border-color: ${theme.colors.primary};
  }

  @media (max-width: 768px) {
    flex: 1;
    justify-content: center;
    padding: 10px 14px;
    font-size: 0.85rem;
  }
`;

const SolidButton = styled(OutlineButton)`
  background: ${theme.colors.primary};
  color: #ffffff;
  border-color: ${theme.colors.primary};
  font-weight: 600;

  &:hover {
    background: #2563eb;
    color: #fff;
    border-color: #2563eb;
  }

  @media (max-width: 768px) {
    flex: 1;
  }
`;

const DetailRow = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 0.375rem;
  }
`;

const IconText = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.8rem;
  color: ${theme.colors.textMuted};
  font-weight: 500;
  padding: 4px 8px;
  background: transparent;
  border-radius: 6px;
  border: 1px solid ${theme.colors.borderLight};
  transition: all 0.15s ease;

  svg {
    flex-shrink: 0;
    width: 14px;
    height: 14px;
  }

  @media (max-width: 768px) {
    font-size: 0.75rem;
    padding: 4px 8px;

    svg {
      width: 12px;
      height: 12px;
    }
  }
`;

const BudgetBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #0f172a;
  background: #f8fafc;
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid ${theme.colors.borderLight};

  @media (max-width: 768px) {
    font-size: 0.8rem;
    padding: 3px 8px;
  }
`;

const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  background: ${props => props.$hasItems ? theme.colors.primaryLight : '#f8fafc'};
  color: ${props => props.$hasItems ? theme.colors.primary : '#6b7280'};
  border: 1px solid ${props => props.$hasItems ? '#dbeafe' : '#e2e8f0'};

  &:hover {
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
  }

  svg {
    width: 14px;
    height: 14px;
  }

  @media (max-width: 768px) {
    font-size: 0.75rem;
    padding: 3px 8px;

    svg {
      width: 12px;
      height: 12px;
    }
  }
`;

/* ------------------------- Offer Chat Styles ------------------------- */
const OfferChat = styled.div`
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid ${theme.colors.borderLight};
`;

const OfferChatHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  font-weight: 500;
  color: ${theme.colors.textMuted};
  font-size: 0.8rem;
`;

const OfferChatCount = styled.span`
  color: ${theme.colors.textMuted};
  font-size: 0.75rem;
  font-weight: 500;
`;

const OfferChatEmpty = styled.div`
  color: ${theme.colors.textMuted};
  font-size: 0.8rem;
  margin-bottom: 6px;
`;

const OfferChatToggle = styled.button`
  background: none;
  border: 0;
  padding: 0;
  color: ${theme.colors.primary};
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  margin-left: auto;

  &:hover {
    text-decoration: underline;
  }
`;

const OfferChatMessages = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
`;

const OfferChatMessage = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

const OfferChatBubble = styled.div`
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 8px 10px;
  max-width: 520px;
`;

const OfferChatMeta = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  font-size: 0.8rem;
  color: ${theme.colors.textMuted};
  margin-bottom: 4px;
`;

const OfferChatText = styled.div`
  font-size: 0.9rem;
  color: ${theme.colors.textBody};
  line-height: 1.35;
`;

const ReplyForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ReplyTextarea = styled.textarea`
  width: 100%;
  min-height: 60px;
  padding: 10px 12px;
  border: 1px solid ${theme.colors.border};
  border-radius: 10px;
  font-size: 0.9rem;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary};
  }
`;

const ReplyActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

const ReplyButton = styled.button`
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &.primary {
    background: ${theme.colors.primary};
    color: white;
    border: none;

    &:hover:not(:disabled) {
      opacity: 0.9;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`;

/* ------------------------- Empty State ------------------------- */
const EmptyState = styled.div`
  background: ${theme.colors.surface};
  border: 1px solid ${theme.colors.borderLight};
  border-radius: ${theme.borderRadius.xl};
  padding: 2.5rem 1.5rem;
  text-align: center;
  box-shadow: ${theme.shadows.sm};
  animation: ${slideInUp} 0.4s ease;

  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

const EmptyIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: ${theme.colors.primaryLight};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  box-shadow: none;

  @media (max-width: 768px) {
    width: 48px;
    height: 48px;
    margin-bottom: 0.75rem;
  }
`;

const EmptyTitle = styled.h3`
  margin: 0 0 0.75rem;
  color: ${theme.colors.textHeading};
  font-size: 1.25rem;
  font-weight: ${theme.fonts.weights.semiBold};
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 1.125rem;
    margin-bottom: 0.5rem;
  }
`;

const EmptyText = styled.p`
  margin: 0 0 1.5rem;
  color: ${theme.colors.textMuted};
  font-size: 0.9rem;
  line-height: 1.6;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  font-weight: ${theme.fonts.weights.normal};

  @media (max-width: 768px) {
    font-size: 0.85rem;
    margin-bottom: 1rem;
  }
`;

const EmptyButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 12px 24px;
  background: ${theme.colors.primary};
  color: white;
  border: none;
  border-radius: ${theme.borderRadius.md};
  font-size: 1rem;
  font-weight: ${theme.fonts.weights.semiBold};
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: ${theme.shadows.sm};

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${theme.shadows.card};
    opacity: 0.9;
  }

  @media (max-width: 768px) {
    padding: 12px 20px;
    font-size: 0.95rem;
  }
`;

/* ------------------------- Loading Skeleton Layouts ------------------------- */
const HeaderSkeleton = () => (
  <SkeletonCard p="0.875rem 1.25rem" style={{ marginBottom: "1rem" }}>
    <Skeleton w="min(240px, 70%)" h="20px" r="8px" />
    <div style={{ marginTop: 4 }}>
      <Skeleton w="min(300px, 80%)" h="12px" />
    </div>
  </SkeletonCard>
);

const MetricsSkeleton = () => (
  <MetricsGrid>
    {Array.from({ length: 4 }).map((_, i) => (
      <SkeletonCard key={i}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Skeleton w="120px" h="12px" />
          <Skeleton w="36px" h="32px" r="8px" />
        </div>
        <div style={{ marginTop: 12 }}>
          <Skeleton w="80px" h="22px" />
        </div>
        <div style={{ marginTop: 8 }}>
          <Skeleton w="130px" h="12px" />
        </div>
      </SkeletonCard>
    ))}
  </MetricsGrid>
);

const PillsSkeleton = () => (
  <div
    style={{
      margin: "12px 0 16px",
      display: "flex",
      gap: "8px",
      flexWrap: "wrap",
      overflow: "hidden" /* Prevent overflow */,
    }}
  >
    {Array.from({ length: 5 }).map((_, i) => (
      <Skeleton key={i} w={`min(${80 + i * 18}px, 25%)`} h="32px" r="999px" />
    ))}
  </div>
);

const ListSkeleton = () => (
  <>
    {Array.from({ length: 4 }).map((_, i) => (
      <SkeletonCard key={i} style={{ marginBottom: "1rem" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              width: "100%",
              gap: "1rem",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.75rem",
                flex: 1,
                flexWrap: "wrap",
                minWidth: 0,
              }}
            >
              <Skeleton w="min(320px, 100%)" h="18px" />
              <Skeleton w="90px" h="24px" r="999px" />
            </div>
            <div
              style={{
                display: "flex",
                gap: "0.5rem",
                flexDirection: "row",
                flexShrink: 0,
              }}
            >
              <Skeleton w="100px" h="34px" r="10px" />
              <Skeleton w="110px" h="34px" r="10px" />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "0.5rem",
              flexDirection: "row",
              flexWrap: "wrap",
            }}
          >
            <Skeleton w="100px" h="16px" />
            <Skeleton w="min(160px, 40%)" h="16px" />
            <Skeleton w="120px" h="16px" />
          </div>
        </div>
      </SkeletonCard>
    ))}
  </>
);

// Helper to parse dates (handles various formats)
const parseDate = (dateStr) => {
  if (!dateStr) return new Date();
  const d = new Date(dateStr);
  return isNaN(d.getTime()) ? new Date() : d;
};

/* ------------------------- Component ------------------------- */
const Dashboard = ({ state }) => {
  const [postedTasks, setPostedTasks] = useState([]);
  const [offers, setOffers] = useState([]);
  const [mainTab, setMainTab] = useState("posted");
  const [filter, setFilter] = useState("all");
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Offer chat state
  const [offerQuestionsById, setOfferQuestionsById] = useState({});
  const [offerQuestionsLoadingById, setOfferQuestionsLoadingById] = useState({});
  const [offerChatExpandedById, setOfferChatExpandedById] = useState({});
  const [offerQuestionTextById, setOfferQuestionTextById] = useState({});
  const [offerQuestionSubmittingById, setOfferQuestionSubmittingById] = useState({});

  // Load offer questions for a specific offer
  const loadOfferQuestions = useCallback(async (offerId, taskId) => {
    if (!offerId || !taskId) return;
    setOfferQuestionsLoadingById((p) => ({ ...p, [offerId]: true }));
    try {
      const { data } = await request("POST", API_CONSTANT_MAP.fetch_task_questions, {
        task_id: taskId,
        offer_id: offerId,
      });
      setOfferQuestionsById((p) => ({
        ...p,
        [offerId]: data?.success ? data.questions : [],
      }));
    } catch (err) {
      console.error("Error fetching offer questions:", err);
    } finally {
      setOfferQuestionsLoadingById((p) => ({ ...p, [offerId]: false }));
    }
  }, []);

  // Submit a new message in offer chat
  const handleOfferQuestionSubmit = async (offerId, taskId) => {
    const text = (offerQuestionTextById[offerId] || "").trim();
    if (!text || offerQuestionSubmittingById[offerId]) return;

    setOfferQuestionSubmittingById((p) => ({ ...p, [offerId]: true }));
    try {
      const response = await request("POST", API_CONSTANT_MAP.submit_task_question, {
        task_id: taskId,
        offer_id: offerId,
        question_text: text,
      });

      if (response.data?.success) {
        // Clear input and refresh messages
        setOfferQuestionTextById((p) => ({ ...p, [offerId]: "" }));
        await loadOfferQuestions(offerId, taskId);
      } else {
        alert("Failed to post message. Please try again.");
      }
    } catch (error) {
      console.error("Error posting offer message:", error);
      alert("Error posting message. Please try again.");
    } finally {
      setOfferQuestionSubmittingById((p) => ({ ...p, [offerId]: false }));
    }
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const [tResp, aResp] = await Promise.all([
          request("POST", API_CONSTANT_MAP.fetch_posted_tasks),
          request("POST", API_CONSTANT_MAP.fetch_user_offers),
        ]);
        if (tResp.data?.success) setPostedTasks(tResp.data.tasks || []);
        if (aResp.data?.success) setOffers(aResp.data.applications || []);
      } catch (e) {
        console.error(e);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  // Pre-load offer chat messages for all offers when offers are fetched
  useEffect(() => {
    if (!offers?.length) return;
    offers.forEach((offer) => {
      if (!offer?.offer_id) return;
      if (offerQuestionsById[offer.offer_id]) return; // Skip if already loaded
      if (offerQuestionsLoadingById[offer.offer_id]) return; // Skip if loading
      loadOfferQuestions(offer.offer_id, offer.id);
    });
  }, [offers, offerQuestionsById, offerQuestionsLoadingById, loadOfferQuestions]);

  // Handle URL params for deep linking to specific offer
  useEffect(() => {
    const offerIdParam = searchParams.get("offer");
    if (offerIdParam && offers.length > 0) {
      // Switch to offers tab
      setMainTab("offers");
      // Find and expand the offer (note: o.offer_id is the actual offer ID, o.id is task_id)
      const targetOffer = offers.find((o) => String(o.offer_id) === offerIdParam);
      if (targetOffer) {
        setOfferChatExpandedById((p) => ({ ...p, [targetOffer.offer_id]: true }));
        // Load the questions for this offer (offer_id, task_id)
        loadOfferQuestions(targetOffer.offer_id, targetOffer.id);
      }
    }
  }, [searchParams, offers, loadOfferQuestions]);

  // Load offer questions when an offer chat is expanded
  useEffect(() => {
    Object.entries(offerChatExpandedById).forEach(([offerId, isExpanded]) => {
      if (isExpanded && !offerQuestionsById[offerId] && !offerQuestionsLoadingById[offerId]) {
        // Note: o.offer_id is the actual offer ID, o.id is task_id
        const offer = offers.find((o) => String(o.offer_id) === offerId);
        if (offer) {
          loadOfferQuestions(offer.offer_id, offer.id);
        }
      }
    });
  }, [offerChatExpandedById, offers, offerQuestionsById, offerQuestionsLoadingById, loadOfferQuestions]);

  const counts = {
    tasksPosted: postedTasks.length,
    offersSent: offers.length,
    activeProjects: postedTasks.filter((t) => t.status === "in_progress")
      .length,
    completedTasks: postedTasks.filter((t) => t.status === "completed").length,
  };

  const tasksList = mainTab === "posted" ? postedTasks : offers;
  const pillKeys =
    mainTab === "posted"
      ? ["all", "open", "in_progress", "completed"]
      : ["all", "pending", "accepted", "rejected"];
  const filtered =
    filter === "all" ? tasksList : tasksList.filter((t) => t.status === filter);

  return (
    <>
      <GlobalStyle />
      <PageWrapper>
        <NavBar user={state.user} />
        <ContentContainer>
          {/* HEADER */}
          {isLoading ? (
            <HeaderSkeleton />
          ) : (
            <HeaderBlock>
              <PageTitle>Welcome back, {state.user.first_name}!</PageTitle>
              <PageSubtitle>
                Manage your tasks and track your progress
              </PageSubtitle>
            </HeaderBlock>
          )}

          {/* METRICS */}
          {isLoading ? (
            <MetricsSkeleton />
          ) : (
            <MetricsGrid>
              <MetricCard
                onClick={() => {
                  setMainTab("posted");
                  setFilter("all");
                }}
              >
                <CardHeader>
                  <MetricTitle>Tasks Posted</MetricTitle>
                  <IconWrapper bg={theme.colors.primaryLight}>
                    <Briefcase size={18} color="hsl(217, 91%, 50%)" />
                  </IconWrapper>
                </CardHeader>
                <MetricValue>{counts.tasksPosted}</MetricValue>
                <MetricSub>Click to filter below</MetricSub>
              </MetricCard>

              <MetricCard
                onClick={() => {
                  setMainTab("offers");
                  setFilter("all");
                }}
              >
                <CardHeader>
                  <MetricTitle>Offers Sent</MetricTitle>
                  <IconWrapper bg="hsl(145, 63%, 95%)">
                    <Send size={18} color="hsl(145, 63%, 42%)" />
                  </IconWrapper>
                </CardHeader>
                <MetricValue>{counts.offersSent}</MetricValue>
                <MetricSub>Click to filter below</MetricSub>
              </MetricCard>

              <MetricCard
                onClick={() => {
                  setMainTab("posted");
                  setFilter("in_progress");
                }}
              >
                <CardHeader>
                  <MetricTitle>Active Projects</MetricTitle>
                  <IconWrapper bg="hsl(217, 91%, 92%)">
                    <Clock size={18} color="#3b82f6" />
                  </IconWrapper>
                </CardHeader>
                <MetricValue>{counts.activeProjects}</MetricValue>
                <MetricSub>Click to filter below</MetricSub>
              </MetricCard>

              <MetricCard
                onClick={() => {
                  setMainTab("posted");
                  setFilter("completed");
                }}
              >
                <CardHeader>
                  <MetricTitle>Completed Tasks</MetricTitle>
                  <IconWrapper bg="#f3e8ff">
                    <CheckCircle size={18} color="#8b5cf6" />
                  </IconWrapper>
                </CardHeader>
                <MetricValue>{counts.completedTasks}</MetricValue>
                <MetricSub>Click to filter below</MetricSub>
              </MetricCard>
            </MetricsGrid>
          )}

          {/* TABS */}
          <TabsContainer>
            {isLoading ? (
              <SkeletonCard>
                <Skeleton w="min(220px, 60%)" h="38px" r="12px" />
              </SkeletonCard>
            ) : (
              <MainTabs>
                <MainTabButton
                  active={mainTab === "posted"}
                  onClick={() => {
                    setMainTab("posted");
                    setFilter("all");
                  }}
                >
                  My Posted Tasks
                </MainTabButton>
                <MainTabButton
                  active={mainTab === "offers"}
                  onClick={() => {
                    setMainTab("offers");
                    setFilter("all");
                  }}
                >
                  My Offers
                </MainTabButton>
              </MainTabs>
            )}
          </TabsContainer>

          {/* INFO SECTION */}
          {!isLoading && mainTab === "posted" && (
            <InfoSection>
              <InfoTitle>💡 Tip:</InfoTitle> Use the "Manage Task" button to review offers from freelancers, answer their questions, and edit your task details.
            </InfoSection>
          )}

          {/* FILTER PILLS */}
          {isLoading ? (
            <PillsSkeleton />
          ) : (
            <FilterPills>
              {pillKeys.map((key) => {
                const label =
                  key === "all"
                    ? `${mainTab === "posted" ? "All Tasks" : "All Offers"} (${
                        tasksList.length
                      })`
                    : `${key.charAt(0).toUpperCase() + key.slice(1)} (${
                        tasksList.filter((t) => t.status === key).length
                      })`;
                return (
                  <Pill
                    key={key}
                    active={filter === key}
                    onClick={() => setFilter(key)}
                  >
                    {label
                      .split("_")
                      .map(
                        (w) =>
                          w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
                      )
                      .join(" ")}
                  </Pill>
                );
              })}
            </FilterPills>
          )}

          {/* LIST */}
          {isLoading ? (
            <ListSkeleton />
          ) : filtered.length === 0 ? (
            <EmptyState>
              <EmptyTitle>
                {mainTab === "posted"
                  ? "No tasks posted yet"
                  : "No offers sent yet"}
              </EmptyTitle>
              <EmptyText>
                {mainTab === "posted"
                  ? "Ready to get things done? Post your first task and start receiving proposals from skilled service providers."
                  : "Browse available tasks and send your first proposal to start earning."}
              </EmptyText>
              <EmptyButton
                onClick={() =>
                  navigate(mainTab === "posted" ? "/posttask" : "/tasks")
                }
              >
                <Plus size={20} />
                {mainTab === "posted" ? "Post Your First Request" : "Find Work"}
              </EmptyButton>
            </EmptyState>
          ) : (
            filtered.map((t) => (
              <TaskCard key={t.id}>
                <CardContent>
                  <TaskHeader>
                    <TitleAndTag>
                      <TaskTitleLink to={`/tasks/${t.id}`}>
                        {toTitleCase(
                          mainTab === "posted" ? t.title : t.task_title
                        )}
                      </TaskTitleLink>
                      <Tag
                        bg={
                          t.status === "pending"
                            ? "hsl(35, 91%, 95%)"
                            : t.status === "accepted"
                            ? "hsl(145, 63%, 95%)"
                            : t.status === "open"
                            ? "hsl(145, 63%, 95%)"
                            : t.status === "rejected"
                            ? "hsl(0, 84%, 95%)"
                            : t.status === "withdrawn"
                            ? "hsl(0, 84%, 95%)"
                            : t.status === "in_progress"
                            ? "#eff6ff"
                            : t.status === "completed"
                            ? "#f3e8ff"
                            : t.status === "cancelled"
                            ? "hsl(0, 84%, 95%)"
                            : "#f0f7ff"
                        }
                        color={
                          t.status === "pending"
                            ? "hsl(35, 91%, 40%)"
                            : t.status === "accepted"
                            ? "hsl(145, 63%, 30%)"
                            : t.status === "open"
                            ? "hsl(145, 63%, 30%)"
                            : t.status === "rejected"
                            ? "hsl(0, 84%, 40%)"
                            : t.status === "withdrawn"
                            ? "hsl(0, 84%, 40%)"
                            : t.status === "in_progress"
                            ? "#2563eb"
                            : t.status === "completed"
                            ? "#7c3aed"
                            : t.status === "cancelled"
                            ? "hsl(0, 84%, 40%)"
                            : "#3b82f6"
                        }
                      >
                        {t.status
                          .split("_")
                          .map(
                            (w) =>
                              w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
                          )
                          .join(" ")}
                      </Tag>
                    </TitleAndTag>

                    <DesktopButtonGroup>
                    {mainTab === "posted" ? (
                      <>
                        {t.conversation_id && (
                          <OutlineButton
                            onClick={() =>
                              navigate(`/chat/${t.conversation_id}`)
                            }
                          >
                            <Eye size={16} /> View Chat
                          </OutlineButton>
                        )}
                        <SolidButton
                          onClick={() => navigate(`/tasks/${t.id}/manage`)}
                          title="Review offers, manage questions, and handle collaboration"
                        >
                          <ExternalLink size={16} /> Manage & Offers
                        </SolidButton>
                      </>
                    ) : (
                      t.status === "accepted" && (
                        <OutlineButton
                          onClick={() =>
                            navigate(`/chat/${t.conversation_id || ""}`)
                          }
                        >
                          <Eye size={16} /> View Chat
                        </OutlineButton>
                      )
                    )}
                  </DesktopButtonGroup>
                </TaskHeader>
                <DetailRow>
                  {mainTab === "posted" ? (
                    <>
                      <BudgetBadge>
                        <DollarSign size={14} />{t.budget}
                      </BudgetBadge>
                      <IconText>
                        <Calendar size={14} />
                        {t.due_date}
                      </IconText>
                      <CountBadge
                        $hasItems={t.proposals > 0}
                        onClick={() => navigate(`/tasks/${t.id}/manage`)}
                        title="Click to manage offers"
                      >
                        <Users size={14} />
                        {t.proposals} offer{t.proposals !== 1 ? "s" : ""}
                      </CountBadge>
                      <CountBadge
                        $hasItems={(t.questions || 0) > 0}
                        onClick={() => navigate(`/tasks/${t.id}/manage?tab=questions`)}
                        title="Click to view questions"
                      >
                        <MessageCircle size={14} />
                        {t.questions || 0} Q&A
                      </CountBadge>
                    </>
                  ) : (
                    <>
                      <IconText style={{ color: "#6b7280" }}>
                        Budget: ${t.budget}
                      </IconText>
                      <BudgetBadge>
                        <DollarSign size={14} />{t.amount}
                      </BudgetBadge>
                      <IconText>
                        <Calendar size={14} />
                        {t.task_due_date}
                      </IconText>
                    </>
                  )}
                </DetailRow>

                {/* Offer Chat Section - only for My Offers tab */}
                {mainTab === "offers" && t.status !== "accepted" && (() => {
                  // Note: t.id is task_id, t.offer_id is the actual offer ID
                  const offerQuestions = offerQuestionsById[t.offer_id] || [];
                  const isOfferQuestionsLoading = !!offerQuestionsLoadingById[t.offer_id];
                  const isOfferChatExpanded = !!offerChatExpandedById[t.offer_id];
                  const offerQuestionText = offerQuestionTextById[t.offer_id] || "";
                  const isOfferSubmitting = !!offerQuestionSubmittingById[t.offer_id];

                  return (
                    <OfferChat>
                      <OfferChatHeader>
                        <MessageCircle size={16} />
                        Offer Discussion
                        <OfferChatCount>({offerQuestions.length})</OfferChatCount>
                        <OfferChatToggle
                          onClick={() =>
                            setOfferChatExpandedById((p) => ({
                              ...p,
                              [t.offer_id]: !isOfferChatExpanded,
                            }))
                          }
                        >
                          {offerQuestions.length === 0
                            ? "Start discussion"
                            : isOfferChatExpanded
                            ? "Hide"
                            : "View"}
                        </OfferChatToggle>
                      </OfferChatHeader>

                      {isOfferQuestionsLoading ? (
                        <OfferChatEmpty>Loading messages…</OfferChatEmpty>
                      ) : offerQuestions.length > 0 && isOfferChatExpanded ? (
                        <OfferChatMessages>
                          {offerQuestions
                            .flatMap((q) => {
                              const base = [{
                                id: `q-${q.id}`,
                                user_id: q.user_id,
                                user_name: q.user_name,
                                avatar: q.avatar,
                                email_verified: q.email_verified,
                                text: q.question_text || q.text,
                                created_at: q.created_at,
                              }];
                              const replies = (q.replies || []).map((reply) => ({
                                id: `r-${reply.id}`,
                                user_id: reply.user_id,
                                user_name: reply.user_name,
                                avatar: reply.avatar,
                                email_verified: reply.email_verified,
                                text: reply.reply_text || reply.text,
                                created_at: reply.created_at,
                              }));
                              return [...base, ...replies];
                            })
                            .sort((a, b) => parseDate(a.created_at) - parseDate(b.created_at))
                            .map((m) => (
                              <OfferChatMessage key={m.id}>
                                <AvatarComponent
                                  src={m.avatar}
                                  firstName={m.user_name}
                                  userId={m.user_id}
                                  size="28px"
                                />
                                <OfferChatBubble>
                                  <OfferChatMeta>
                                    <span>{(m.user_name || "Anonymous User").toLowerCase().replace(/\b\w/g, l => l.toUpperCase())}</span>
                                    <span>·</span>
                                    <span>
                                      {formatDistanceToNow(parseDate(m.created_at), {
                                        addSuffix: true,
                                      })}
                                    </span>
                                  </OfferChatMeta>
                                  <OfferChatText>{m.text}</OfferChatText>
                                </OfferChatBubble>
                              </OfferChatMessage>
                            ))}
                        </OfferChatMessages>
                      ) : null}

                      {isOfferChatExpanded && (
                        <ReplyForm style={{ marginTop: "6px" }}>
                          <ReplyTextarea
                            value={offerQuestionText}
                            onChange={(e) =>
                              setOfferQuestionTextById((p) => ({
                                ...p,
                                [t.offer_id]: e.target.value,
                              }))
                            }
                            placeholder="Message about your offer..."
                          />
                          <ReplyActions>
                            <ReplyButton
                              className="primary"
                              onClick={() => handleOfferQuestionSubmit(t.offer_id, t.id)}
                              disabled={!offerQuestionText.trim() || isOfferSubmitting}
                            >
                              {isOfferSubmitting ? "Posting..." : "Post Message"}
                            </ReplyButton>
                          </ReplyActions>
                        </ReplyForm>
                      )}
                    </OfferChat>
                  );
                })()}

                <ButtonGroup>
                  {mainTab === "posted" ? (
                    <>
                      {t.conversation_id && (
                        <OutlineButton
                          onClick={() =>
                            navigate(`/chat/${t.conversation_id}`)
                          }
                        >
                          <Eye size={16} /> View Chat
                        </OutlineButton>
                      )}
                      <SolidButton
                        onClick={() => navigate(`/tasks/${t.id}/manage`)}
                        title="Review offers, manage questions, and handle collaboration"
                      >
                        <ExternalLink size={16} /> Manage & Offers
                      </SolidButton>
                    </>
                  ) : (
                    t.status === "accepted" && (
                      <OutlineButton
                        onClick={() =>
                          navigate(`/chat/${t.conversation_id || ""}`)
                        }
                      >
                        <Eye size={16} /> View Chat
                      </OutlineButton>
                    )
                  )}
                </ButtonGroup>
                </CardContent>
              </TaskCard>
            ))
          )}
        </ContentContainer>
      </PageWrapper>
    </>
  );
};

export default connect((state) => ({ state }))(Dashboard);
